import _merge from 'lodash/merge';
import { Lightning } from '@lightningjs/sdk';
import { contain } from '../../utils/textures';
import { defaultContext, GAP, getInitialStyle, LOGO_DIMENSIONS } from './podcastInformationTop.style';

export class PodcastInformationTop extends Lightning.Component {
  static _template() {
    return _merge(
      {
        Logo: {},
        Title: {},
      },
      getInitialStyle(),
    );
  }

  _construct() {
    this._style = defaultContext;
  }

  _detach() {
    this.tag('Title').removeAllListeners('txLoaded');
  }

  set data(content) {
    if (!content) {
      return;
    }

    const { screenSize } = this._style;
    const { logo } = content;
    const logoSrc = (logo && logo.src) || '';
    const height =
      GAP[screenSize] + (logoSrc ? LOGO_DIMENSIONS[screenSize].height : 0) + (content.title ? GAP[screenSize] : 0);

    if (content.title) {
      this.tag('Title').once('txLoaded', texture => {
        this.h = height + texture.source.h;

        this.emit('txLoaded');
      });
    } else {
      this.h = height;

      this.emit('txLoaded');
    }

    this.patch({
      Logo: {
        visible: Boolean(logoSrc),
        texture: contain(logoSrc, LOGO_DIMENSIONS[screenSize].width, LOGO_DIMENSIONS[screenSize].height),
      },
      Title: {
        visible: Boolean(content.title),
        text: {
          text: content.title,
        },
      },
    });
  }
}
